import { OrientedBoundingBox } from "@/components/r3f/utils/oriented-bounding-box";
import { Box3, Matrix4, Quaternion, Vector3 } from "three";

/**
 * @param region An oriented box
 * @returns the axis aligned box containing it
 */
export function regionBounds(region: OrientedBoundingBox): Box3 {
  return new Box3(
    new Vector3(-0.5, -0.5, -0.5),
    new Vector3(0.5, 0.5, 0.5),
  ).applyMatrix4(
    new Matrix4().compose(
      new Vector3().fromArray(region.position),
      new Quaternion().fromArray(region.rotation),
      new Vector3().fromArray(region.size),
    ),
  );
}

/**
 * @param positions Point positions as x, y, z triplets, relative to origin
 * @param origin World position the points are relative to
 * @param region World region to keep
 * @returns the points inside the region, still relative to origin
 */
export function filterPointsInRegion(
  positions: Float32Array,
  origin: Vector3,
  region: OrientedBoundingBox,
): Float32Array {
  // Maps the points to the unit box of the region, where inside means |x|, |y|, |z| <= 0.5
  const toRegion = new Matrix4()
    .compose(
      new Vector3().fromArray(region.position).sub(origin),
      new Quaternion().fromArray(region.rotation),
      new Vector3().fromArray(region.size),
    )
    .invert();
  const kept = new Float32Array(positions.length);
  const point = new Vector3();
  let count = 0;
  for (let i = 0; i < positions.length; i += 3) {
    point.fromArray(positions, i).applyMatrix4(toRegion);
    if (
      Math.abs(point.x) <= 0.5 &&
      Math.abs(point.y) <= 0.5 &&
      Math.abs(point.z) <= 0.5
    ) {
      kept.set(positions.subarray(i, i + 3), count * 3);
      count++;
    }
  }
  return kept.slice(0, count * 3);
}
